



















import Vue from 'vue';
import Component from 'vue-class-component';

@Component({
	name: 'SectionLoader',
	props: {
		loading: Boolean,
		scale: { type: Number, default: 1 },
	},
})
export default class SectionLoader extends Vue {
	public loading!: boolean;
	public scale!: number;
}
